import { render, staticRenderFns } from "./chat-records.vue?vue&type=template&id=11c99b16&scoped=true"
import script from "./chat-records.vue?vue&type=script&lang=js"
export * from "./chat-records.vue?vue&type=script&lang=js"
import style0 from "./chat-records.vue?vue&type=style&index=0&id=11c99b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c99b16",
  null
  
)

export default component.exports